// @flow
import * as React from 'react';

import {
  PrimaryText, Label, Success, Error,
} from '../../../Typography.jsx';
import developmentItems from '../developmentItems';

type Props = {
  developmentMilestones: boolean[],
  developmentNormal: boolean,
  developmentNotes: string,
  developmentGrade: string,
  type: number,
}

class ViewDevelopment extends React.Component<Props> {
  render() {
    const developmentContent = developmentItems[this.props.type].map(
      (item, index) => (
        <tr key={item}>
          <td>{this.props.developmentMilestones[index] === false ? <Error>✗</Error>
            : this.props.developmentMilestones[index] ? <Success>✓</Success> : '--'}</td>
          <td>
            {item}
            {(item === 'Grade')
            && `: ${this.props.developmentGrade || '--'}`}</td>
        </tr>
      ),
    );

    return (
      <div>
        <PrimaryText>Development Milestones</PrimaryText>
        <table>
          <tbody>
            {developmentContent}
          </tbody>
        </table>
        <br />
        <div>
          <PrimaryText>Development Result: </PrimaryText>
          {this.props.developmentNormal === false
            ? 'Delayed' : this.props.developmentNormal ? 'Normal' : '--'}
        </div>
        <div>
          <Label>Development Notes: </Label>
          {this.props.developmentNotes || 'None'}
        </div>
      </div>
    );
  }
}

export default ViewDevelopment;



// WEBPACK FOOTER //
// ./client/src/components/patientPages/wellChildCheck/view/ViewDevelopment.jsx